const DESKTOP = '(min-width: 992px)';
const VIEWPORT_GUTTER = 20;

function isDesktop() {
    return window.matchMedia(DESKTOP).matches;
}

function positionDropdown(menuItem) {
    let panel = menuItem.find('> .dropdown-container'),
        container = menuItem.closest('.site-header-row-two .container');

    if (panel.length === 0 || container.length === 0) {
        return;
    }

    let containerEl = container[0],
        containerLeft = containerEl.getBoundingClientRect().left,
        offset = menuItem[0].getBoundingClientRect().left
            - containerLeft
            - (parseFloat(window.getComputedStyle(panel[0]).paddingLeft) || 0),
        minLeft = -containerLeft + VIEWPORT_GUTTER,
        maxLeft = containerEl.clientWidth - panel[0].offsetWidth;

    panel.css('left', Math.max(minLeft, Math.min(offset, maxLeft)) + 'px');
}

function clearDropdowns() {
    $('.site-header-row-two .menu-item.is-dropdown > .dropdown-container').css('left', '');
}

// app-core is imported first, so site-header.js has already shown the panel by the time we measure it.
$('.site-header-row-two .menu-item.is-dropdown > a').on('click', function() {
    let menuItem = $(this).parent();

    if (!isDesktop() || menuItem.hasClass('is-hidden')) {
        return;
    }

    positionDropdown(menuItem);
});

let resizeTimer = null;

$(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        if (!isDesktop()) {
            clearDropdowns();
            return;
        }

        $('.site-header-row-two .menu-item.is-dropdown').not('.is-hidden').each(function() {
            positionDropdown($(this));
        });
    }, 150);
});
